<template>
  <div v-if="visible" class="page-con">
    <InJzxTool
      v-if="visible"
      page-type="5"
      :page-params="pageParams"
      @event-handle="eventHandle"
    />
  </div>
</template>
<script>
import InJzxTool from '@/components/InJzxTool/index.vue'
import { EVENT } from '@/utils/Postmate'
export default {
  name: 'ViewReportDrawer',
  components: {
    InJzxTool
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    pageParams: {
      type: Object
    }
  },
  data() {
    return {
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    eventHandle(data) {
      if (data.type === EVENT.CLOSE_PAGE && data.msg?.scene === 100) {
        this.close()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.page-con {
  width: 100vw;
  height: 100vh;
  position: fixed;
  overflow: hidden;
  z-index: 9999;
}
</style>